<div class="content-general">
  <div class="general">
    <div class="tabs">
      <button
        *ngIf="
          viewSelected == '1' &&
          elementSelected &&
          elementSelected.pk == 'version'
        "
        [ngClass]="{ 'mg-button-selected': isPreview }"
        (click)="preview()"
        class="btn-style flex justify-content-center align-items-center me-1"
      >
        <span
          [ngClass]="{ 'mg-button-icon-selected': isPreview }"
          class="material-symbols-outlined icon-style"
        >
          visibility
        </span>
        <span
          [ngClass]="{ 'mg-button-icon-selected': isPreview }"
          class="text-sm"
          >Preview</span
        >
      </button>

      <div></div>

      <app-tabs
        [tabs]="tabs"
        [blocked]="false"
        [view]="viewSelected"
        (activeTab)="activeTab($event)"
      ></app-tabs>
    </div>

    <!-- {{selectedProperties | json}}<br>
    {{valuesData | json}}<br> -->

    <!-- TAB 1-->
    <div *ngIf="viewSelected == '1'" class="view-selected">
      <!-- NO VERSION -->
      <div
        *ngIf="elementSelected && elementSelected.pk == 'form'"
        class="mg-no-form-container"
      >
        <span class="material-symbols-outlined mg-no-form-icon">
          conversion_path
        </span>
        <span class="mg-no-form-text">
          No version selected. Data is only associated with forms versions
        </span>
      </div>
      <!-- NO DATA -->
      <div
        *ngIf="
          elementSelected &&
          elementSelected.pk == 'version' &&
          values?.length == 0
        "
        class="mg-no-form-container"
      >
        <span class="material-symbols-outlined mg-no-form-icon">
          data_table
        </span>
        <span class="mg-no-form-text">
          No data has been registered for this version
        </span>
      </div>
      <!-- TABLE  -->
      <div
        class="container-table"
        *ngIf="
          elementSelected &&
          elementSelected.pk == 'version' &&
          values?.length > 0
        "
        [ngClass]="{ 'container-table-resize': showSearchToolbar }"
      >
        <ngx-datatable
          class="bootstrap"
          [rows]="valuesData"
          [columnMode]="columnMode.force"
          [headerHeight]="50"
          [footerHeight]="0"
          [rowHeight]="40"
          [scrollbarV]="true"
          [selected]="selectedData"
          [selectionType]="selectionType.checkbox"
          [selectAllRowsOnPage]="false"
          (select)="onSelect($event)"
          (sort)="sortTable($event)"
        >
          <!-- CHECKBOX -->
          <ngx-datatable-column
            [flexGrow]="1"
            [width]="50"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
          >
            <ng-template
              ngx-datatable-header-template
              let-value="value"
              let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn"
            >
              <div class="mng-checkbox">
                <input
                  type="checkbox"
                  [checked]="allRowsSelected"
                  (change)="selectFn(!allRowsSelected)"
                />
                <span class="checkbox"></span>
              </div>
            </ng-template>
            <!-- <ng-template
            ngx-datatable-cell-template
            let-value="value"
            let-isSelected="isSelected"
            let-onCheckboxChangeFn="onCheckboxChangeFn"
          >
            <div class="mng-checkbox">
              <input type="checkbox"
                    [checked]="isSelected"
                    (change)="onCheckboxChangeFn($event)"
              />
              <span class="checkbox"></span>
            </div>
          </ng-template> -->
          </ngx-datatable-column>

          <!-- VALUES      -->
          <ngx-datatable-column
            [headerClass]="'header-style'"
            [minWidth]="200"
            [flexGrow]="1"
            *ngFor="let prop of selectedProperties"
            name="{{ prop.label | uppercase }}"
            prop="{{ prop.name }}"
          >
            <!-- <ng-template
              ngx-datatable-cell-template
              let-value="value"
              let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn"
            >
              <span>{{ value[0]["data_key"] }}</span>
            </ng-template> -->
          </ngx-datatable-column>

          <!-- ACTIONS -->
          <!-- <ngx-datatable-column
            [headerClass]="'header-style'"
            [flexGrow]="1"
            [width]="100"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
          >
          <ng-template ngx-datatable-header-template>
            <div>
              <label>ACTIONS</label>
            </div>
          </ng-template>

          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
          > -->
          <!-- Disabled -->
          <!-- <span *ngIf="elementSelected && elementSelected.pk != 'version'" class="material-symbols-outlined icon-update" (click)="update(rowIndex)">
              edit
            </span>
            &nbsp;&nbsp;&nbsp;
            <span *ngIf="elementSelected && elementSelected.pk != 'version'" class="material-symbols-outlined icon-delete" (click)="delete(rowIndex)">
              delete
            </span> -->
          <!-- Enabled -->
          <!-- <span *ngIf="elementSelected && elementSelected.pk == 'version'" class="disabled material-symbols-outlined icon-update">
              edit
            </span>
            &nbsp;&nbsp;&nbsp;
            <span *ngIf="elementSelected && elementSelected.pk == 'version'" class="disabled material-symbols-outlined icon-delete">
              delete
            </span>
          </ng-template>
        </ngx-datatable-column> -->
        </ngx-datatable>
      </div>
    </div>

    <!-- TAB 2 -->
    <div *ngIf="viewSelected == '2'">
      <!-- NO VERSION -->
      <div
        *ngIf="
          elementSelected &&
          elementSelected.pk == 'form' &&
          versions.length == 0
        "
        class="mg-no-form-container"
      >
        <span class="material-symbols-outlined mg-no-form-icon">
          conversion_path
        </span>
        <span class="mg-no-form-text">
          This form does not have any published version.
        </span>
      </div>
      <div
        *ngIf="
          elementSelected &&
          elementSelected.pk == 'form' &&
          versions.length > 0 &&
          elementSelected.layout.length == 0
        "
        class="mg-no-form-container"
      >
        <span class="material-symbols-outlined mg-no-form-icon">
          list_alt
        </span>
        <span class="mg-no-form-text">
          No layout found. Please create a page for share
        </span>
      </div>

      <div
        *ngIf="
          elementSelected &&
          elementSelected.pk == 'version' &&
          elementSelected.layout.length == 0
        "
        class="mg-no-form-container"
      >
        <span class="material-symbols-outlined mg-no-form-icon">
          list_alt
        </span>
        <span class="mg-no-form-text">
          No layout found. Please create a page for share
        </span>
      </div>
      <!-- SHARE -->
      <div
        *ngIf="
          elementSelected &&
          elementSelected.layout.length > 0 &&
          versions.length > 0
        "
      >
        SHARE HERE<br />
        {{ baseUrl }}<br />
      </div>
    </div>
  </div>
</div>

<!-- <div class="view">
  
  <div class="view__content">
    <div *ngIf="elementSelected && elementSelected.pk == 'version'">
      <div *ngFor="let value of values; index as i">
        {{value.data | json}}
      </div>
    </div>
  </div>

</div> -->
